import {
  USERLOGINFETCH,
  USERLOGINSUCCESS,
  USERLOGINFAILED,
  USERLOGOUT,
  USERLOGININFO,
  LOADACTION,
  LOADEDACTION,
  TOGGLE_MODAL_PROFILE,
  TOGGLE_MODAL_COMPANY,
} from "../config";
import { USERUPDATECOMPANY } from '../config/ConstantsAuth';

export const userLoginFetch = (value: object) => ({
  type: USERLOGINFETCH,
  data: value,
});
export const userLoginSuccess = (value: object) => ({
  type: USERLOGINSUCCESS,
  data: value,
});
export const userLoginFailed = (value: object) => ({
  type: USERLOGINFAILED,
  data: value,
});

export const userUpdateCompany = (value: object) => ({
  type: USERUPDATECOMPANY,
  data: value,
});
export const userLoginInfo = () => ({ type: USERLOGININFO, data: {} });
export const userLogout = () => ({ type: USERLOGOUT });

export const loadAction = () => ({ type: LOADACTION });
export const loadedAction = () => ({ type: LOADEDACTION });
export const toggleModalProfile = () => ({
  type: TOGGLE_MODAL_PROFILE,
});
export const toggleModalCompany = () => ({
  type: TOGGLE_MODAL_COMPANY,
});

export const showPrivacyPolicy = (value: object) => ({
  type: 'SHOW_PRIVACY_POLICY',
  data: value,
});

export const acceptPrivacyPolicy = () => ({
  type: 'ACCEPT_PRIVACY_POLICY',
});
